import React, { useEffect, createElement } from 'react';
import { Home } from './pages/Home';
import { initPixel } from './lib/pixel';
const SITE_TITLE = "THE INTERNET'S MOST WANTED MASK";
const SITE_DESCRIPTION = 'The ultimate tactical mask. Interchangeable lenses, all-day comfort, and an aggressive design built to turn heads.';
const SITE_IMAGE = 'https://cdn.magicpatterns.com/uploads/1VfFbzeG6PLWskxprS5dbU/hf_20260519_142822_5efe37ff-2148-46ab-b7c6-85a4e80d80c1.png';
// Keep the document title + social/preview meta tags clean so shared links
// don't surface stray build text. NOTE: social crawlers (WhatsApp, iMessage,
// Facebook, etc.) read STATIC HTML meta at crawl time and do not run this JS —
// the definitive fix for the shared preview card lives in the PUBLISH settings.
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initPixel();
    document.title = SITE_TITLE;
    setMeta('name', 'description', SITE_DESCRIPTION);
    setMeta('property', 'og:title', SITE_TITLE);
    setMeta('property', 'og:description', SITE_DESCRIPTION);
    setMeta('property', 'og:image', SITE_IMAGE);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SITE_TITLE);
    setMeta('name', 'twitter:description', SITE_DESCRIPTION);
    setMeta('name', 'twitter:image', SITE_IMAGE);
  }, []);
  return <Home data-id="element-0" data-mp="3dkuv81acbeqp" />;
}